import { ErrorHandler, NgModule } from '@angular/core';
import { TelemetryModule } from 'common/telemetry/telemetry.module';
import { ErrorHandlerService } from './error-handler.service';

@NgModule({
  imports: [
    TelemetryModule
  ],
  providers: [
    { provide: ErrorHandler, useClass: ErrorHandlerService }
  ]
})
export class ErrorHandlerModule {
}
